"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82603,48308],{

/***/ 82964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TabListNameEnums; },
/* harmony export */   "F": function() { return /* binding */ CompanyActionEnums; }
/* harmony export */ });
var CompanyActionEnums;
(function(CompanyActionEnums) {
    CompanyActionEnums["STREAM"] = "stream";
    CompanyActionEnums["NEWS"] = "news";
    CompanyActionEnums["KEYSTATS"] = "keystats";
    CompanyActionEnums["FINANCIALS"] = "financials";
    CompanyActionEnums["FUNDACHART"] = "fundachart";
    CompanyActionEnums["CHARTBIT"] = "chartbit";
    CompanyActionEnums["COMPARISON"] = "comparison";
    CompanyActionEnums["INSIDER"] = "insider";
    CompanyActionEnums["PROFILE"] = "profile";
    CompanyActionEnums["CORPACTION"] = "corp_action";
    CompanyActionEnums["SEASONALITY"] = "seasonality";
    CompanyActionEnums["ANALYST"] = "analysis";
})(CompanyActionEnums || (CompanyActionEnums = {}));
var TabListNameEnums;
(function(TabListNameEnums) {
    TabListNameEnums["HOME"] = "";
    TabListNameEnums["STREAM"] = "stream";
    TabListNameEnums["NEWS"] = "news";
    TabListNameEnums["KEYSTATS"] = "keystats";
    TabListNameEnums["ANALYST"] = "analyst";
    TabListNameEnums["FINANCIALS"] = "financials";
    TabListNameEnums["FUNDACHART"] = "fundachart";
    TabListNameEnums["SEASONALITY"] = "seasonality";
    TabListNameEnums["CHARTBIT"] = "chartbit";
    TabListNameEnums["COMPARISON"] = "comparison";
    TabListNameEnums["INSIDER"] = "insider";
    TabListNameEnums["PROFILE"] = "profile";
    TabListNameEnums["CORP_ACTION"] = "corp.action";
    TabListNameEnums["CONSENSUS"] = "EPS Estimate";
    TabListNameEnums["CORP_ACTION_NEW_NAME"] = "corpaction";
    TabListNameEnums["BUY"] = "buy";
})(TabListNameEnums || (TabListNameEnums = {}));


/***/ }),

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 81301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-card-head-title {\n      display: flex;\n      align-items: center;\n      font-size: 18px;\n      font-weight: 400;\n      color: ",
        ";\n    }\n\n    .ant-card-extra {\n      font-size: 18px;\n      text-align: right;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        background-color: ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n  flex-direction: column;\n  width: ",
        ";\n\n  .ant-card-head {\n    padding: ",
        ";\n    ",
        "\n  }\n\n  .ant-card-head-title {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-card-body {\n    padding: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    "profile-config": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary)
};
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || false,
        headerBackground: props.headerBackground,
        width: props.width || "100%",
        bodyPadding: props.bodyPadding || "20px",
        headPadding: props.headPadding || "0 20px",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-5f118f4a-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var headPadding = param.headPadding;
    return headPadding;
}, function(param) {
    var headerBackground = param.headerBackground;
    return headerBackground && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), headerBackground);
}, function(param) {
    var bodyPadding = param.bodyPadding;
    return bodyPadding;
}, function(param) {
    var variant = param.variant;
    return variant && variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 70420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35851);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  border: 1px solid ',
        " !important;\n  border-color: ",
        " !important;\n  box-shadow: none !important;\n\n  :hover,\n  :focus {\n    border: 1px solid ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c892a315-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro));


/***/ }),

/***/ 8089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h_": function() { return /* binding */ DropdownMenu; }
/* harmony export */ });
/* unused harmony export MoreIcon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38504);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84607);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px !important;\n  border-right: none;\n  width: 256px;\n\n  li {\n    height: 30px;\n    line-height: 30px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n\n  .ant-dropdown-menu-item .ant-dropdown-menu-item-only-child {\n    display: flex;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-cd7a91fb-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
var MenuItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Item */ .Z.Item).withConfig({
    componentId: "sc-cd7a91fb-2"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro + (0,_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(80));
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-cd7a91fb-3"
})(_templateObject3());
Dropdown.Menu = Menu;
Dropdown.Menu.Item = MenuItem;
Dropdown.MoreIcon = MoreIcon;
var DropdownMenu = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, Menu), {
    Item: MenuItem
});

/* harmony default export */ __webpack_exports__["ZP"] = (Dropdown);


/***/ }),

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: ",
        ";\n    height: ",
        ";\n    margin: 2px;\n    border-radius: 50%;\n    border: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical,
        filled: props.filled,
        size: props.size
    };
}).withConfig({
    componentId: "sc-2aaf9a0-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, function(param) {
    var size = param.size;
    return size === "small" ? "3px" : "5px";
}, function(param) {
    var size = param.size;
    return size === "small" ? "3px" : "5px";
}, function(param) {
    var filled = param.filled;
    return filled ? "none" : "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
}, function(param) {
    var filled = param.filled;
    return filled ? _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray : "transparent";
});
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 23906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95541);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: 0.2s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: relative;\n  background-color: ",
        ';\n  transition: 0.2s;\n\n  ::before {\n    content: "";\n    display: block;\n    position: absolute;\n    width: 0px;\n    height: 1px;\n    background-color: ',
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n\n  input {\n    position: inherit;\n    z-index: 1;\n    border: none;\n    background: transparent;\n  }\n\n  input::placeholder {\n    color: transparent;\n  }\n\n  input:focus {\n    outline: 0;\n  }\n\n  input:focus ~ ",
        ", input:not(:placeholder-shown) ~ ",
        " {\n    top: -20px;\n    font-size: 13px;\n  }\n\n  input:focus ~ ",
        "::before {\n    width: 100%;\n    transition: 0.5s;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var Label = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    height: "28px",
    color: _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].midgray */ .Z.midgray,
    size: "16px",
    as: "label"
}).withConfig({
    componentId: "sc-c91cfec7-0"
})(_templateObject());
var Bar = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        activeColorBars: props.activeColorBar
    };
}).withConfig({
    componentId: "sc-c91cfec7-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, function(param) {
    var activeColorBar = param.activeColorBar;
    return activeColorBar || _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c91cfec7-2"
})(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, Label, Label, Bar, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props));
});
var InputContainer = function(_param) {
    var children = _param.children, className = _param.className, activeColorBar = _param.activeColorBar, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "activeColorBar"
    ]);
    var childrenProps = children.props;
    var placeholder = childrenProps.placeholder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Bar, {
                activeColorBar: activeColorBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                children: placeholder || " "
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputContainer);


/***/ }),

/***/ 61645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ InputNumberContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69428);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);
/* eslint-disable react/jsx-props-no-spreading */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  justify-content: space-between;\n  width: 160px;\n  @media ",
        " {\n    margin: 0 15px;\n  }\n\n  .ant-input-number-focused,\n  .ant-input-number:hover,\n  .ant-input-number {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    height: 100%;\n    background: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: none;\n  }\n  .ant-input-number-handler {\n    background: #f5f6f7;\n    height: 30px;\n    line-height: 30px;\n    display: inline-block;\n    width: 30px;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    left: 128px;\n    border-left: 1px solid ",
        ';\n    cursor: pointer;\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJElEQVQI12P4//8/AwxnZ2f/R+YzMeABeCUZs7Oz/+OUpY2dAKdAKqbFFo6PAAAAAElFTkSuQmCC");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    border: none;\n    border-right: 1px solid ',
        ';\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQI12P8//8/Ay7AxIAH4JVkzM7OxmkuI23sBABa8QhG3y64OwAAAABJRU5ErkJggg==");\n    }\n  }\n  .ant-input-number-input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down,\n  .ant-input-number-handler-down:hover,\n  .ant-input-number-handler-up {\n    height: 30px !important;\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47fea7ce-0"
})(_templateObject());
var InputNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-47fea7ce-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);

/* harmony default export */ __webpack_exports__["Z"] = (InputNumber);


/***/ }),

/***/ 63757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58928);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  margin: 2.5px 5px 2.5px 7.5px;\n  width: 5px;\n  height: 5px;\n  border: 1px solid ",
        ";\n  border-radius: 50px;\n  float: none;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px;\n\n  li {\n    height: 28px;\n    line-height: 28px;\n    padding: 0 10px;\n    font-size: 14px;\n  }\n\n  li:hover {\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var MoreIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-d17ef6e0-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highgray */ .Z.highgray);
var Menu = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-d17ef6e0-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].whisper */ .Z.whisper, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary);
Menu.MoreIcon = MoreIcon;
/* harmony default export */ __webpack_exports__["Z"] = (Menu);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 35266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56673);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n    .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-next {\n      border: 1px solid ",
        ";\n      a {\n        padding: 0 10px;\n      }\n    }\n\n    .ant-pagination-prev,\n    .ant-pagination-jump-prev,\n    .ant-pagination-jump-next {\n      margin-right: 0;\n      border: 1px solid ",
        ";\n    }\n\n    .ant-pagination-item {\n      margin-right: 0;\n      border-radius: 0;\n      border-color: ",
        ";\n\n      a {\n        color: ",
        ";\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .ant-pagination-item-active {\n      a {\n        color: ",
        ";\n        font-weight: 600;\n      }\n      background: ",
        ";\n    }\n\n    .ant-pagination-prev:focus .ant-pagination-item-link,\n    .ant-pagination-next:focus .ant-pagination-item-link,\n    .ant-pagination-prev:hover .ant-pagination-item-link,\n    .ant-pagination-next:hover .ant-pagination-item-link {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var type = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro)
};
var Pagination = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "basic"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-31bb62cf-0"
})(_templateObject2(), function(props) {
    return type[props.type];
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 6305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        "\n\n  .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8dcb9882-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 77148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79931);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    .ant-table-thead > tr > th {\n      background: ",
        ";\n    }\n\n    .ant-table-tbody > tr > td {\n      padding: 8px 15px;\n    }\n\n    .ant-table-column-sorter {\n      position: absolute;\n      right: 0;\n    }\n\n    .ant-table-column-sorter-up,\n    .ant-table-column-sorter-down {\n      display: none;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover {\n      background-color: unset;\n    }\n\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-up,\n    .ant-table-thead th.ant-table-column-has-sorters:hover .ant-table-column-sorter-down {\n      display: block;\n    }\n\n    .ant-table-column-sorter-up.active,\n    .ant-table-column-sorter-down.active {\n      color: ",
        ";\n      display: block;\n    }\n\n    .ant-empty-image {\n      display: none;\n    }\n\n    .ant-empty-normal {\n      margin: unset;\n    }\n\n    .ant-table-ping-left .ant-table-cell-fix-left-last::after {\n      box-shadow: unset;\n    }\n\n    .ant-table-container::after {\n      content: unset;\n    }\n\n    .ant-pagination-prev {\n      margin: unset;\n    }\n    .ant-pagination-item {\n      display: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis)
};
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-24c3e4c6-0"
})(_templateObject1(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 50864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: none;\n  outline: 0 !important;\n\n  .selected-flag {\n    height: 35px;\n    border: 1px solid ",
        ";\n    outline: 0;\n  }\n\n  > .react-tel-input.country-list {\n    list-style: none;\n    position: absolute !important;\n    z-index: 500 !important;\n    padding: 0;\n    margin: -1px 0 0 -1px;\n    background-color: ",
        ';\n    width: 310px;\n    max-height: 200px;\n    overflow-y: scroll;\n    border-radius: 0 0 3px 3px;\n    top: 34px;\n  }\n\n  input[type="tel"] {\n    outline: 0;\n    line-height: 35px;\n    height: 35px;\n    font-weight: 300;\n    width: 100%;\n    border: none;\n    font-size: 20px;\n    position: relative;\n    border-bottom: 1px solid ',
        ';\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  input[type="tel"]:focus,\n  input[type="text"]:focus {\n    border-color: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TelephoneInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_1___default())).withConfig({
    componentId: "sc-dcb2dc87-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary);
/* harmony default export */ __webpack_exports__["Z"] = (TelephoneInput);


/***/ }),

/***/ 39211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56266);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-71cb950b-0"
})(_templateObject()));


/***/ }),

/***/ 48308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "Mt": function() { return /* reexport */ DatePicker/* default */.Z; },
  "kC": function() { return /* reexport */ Flex/* default */.Z; },
  "Bn": function() { return /* reexport */ IconMoreOptions/* default */.Z; },
  "ST": function() { return /* reexport */ Iconmoon/* default */.Z; },
  "II": function() { return /* reexport */ Input/* default */.Z; },
  "u_": function() { return /* reexport */ Modal/* default */.Z; },
  "J2": function() { return /* reexport */ Popover/* default */.ZP; },
  "Ph": function() { return /* reexport */ Select/* default */.Z; },
  "xv": function() { return /* reexport */ Text/* default */.Z; },
  "u": function() { return /* reexport */ Tooltip/* default */.Z; }
});

// UNUSED EXPORTS: Autocomplete, Avatar, Card, Collapse, Dropdown, IconBase64, IconWrapper, InputContainer, InputNumber, InputNumberContainer, Menu, Pagination, PopoverContent, PopoverContentWrapper, PopoverTitleWrapper, Radio, Steps, Table, Tabs, Tag, TelephoneInput, Textarea

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/DatePicker.js
var DatePicker = __webpack_require__(70420);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconBase64.js
var IconBase64 = __webpack_require__(37949);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputForm.js
var InputForm = __webpack_require__(23906);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/InputNumber.js
var InputNumber = __webpack_require__(61645);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Card.js
var Card = __webpack_require__(81301);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js + 3 modules
var react_textarea_autosize_browser_esm = __webpack_require__(93463);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/hoc/withSpacing.js
var withSpacing = __webpack_require__(97214);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Textarea.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  width: 100%;\n  resize: none;\n\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Textarea = (0,styled_components_browser_esm/* default */.ZP)(react_textarea_autosize_browser_esm/* default */.Z).withConfig({
    componentId: "sc-d3c3a5a9-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro);
/* harmony default export */ var common_Textarea = ((0,withSpacing/* default */.Z)(Textarea));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Dropdown.js
var Dropdown = __webpack_require__(8089);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/TelephoneInput.js
var TelephoneInput = __webpack_require__(50864);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Menu.js
var Menu = __webpack_require__(63757);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Checkbox.js
var Checkbox = __webpack_require__(81190);
// EXTERNAL MODULE: ./node_modules/antd/es/tabs/index.js + 15 modules
var tabs = __webpack_require__(76750);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Tabs.js

function Tabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .ant-tabs-nav {\n      margin: 0;\n    }\n\n    .ant-tabs-nav-list {\n      width: 100%;\n    }\n    .ant-tabs-tab {\n      margin-right: 0px !important;\n      width: 100%;\n      text-align: center;\n      display: block;\n      font-size: 16px;\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    .ant-tabs-nav .ant-tabs-nav-list {\n      border: 1px solid ",
        ";\n    }\n\n    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,\n    .ant-tabs-tab .ant-tabs-tab-active {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var variants = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Tabs_templateObject()),
    "full-width": (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), color/* default.highempahis */.Z.highempahis, color/* default.whiteSmoke */.Z.whiteSmoke, color/* default.highempahis */.Z.highempahis)
};
var Tabs = (0,styled_components_browser_esm/* default */.ZP)(tabs/* default */.Z).attrs(function(props) {
    return {
        variant: props.variant || "basic"
    };
}).withConfig({
    componentId: "sc-ccea26c3-0"
})(_templateObject2(), function(param) {
    var variant = param.variant;
    return variants[variant];
});
/* harmony default export */ var common_Tabs = ((/* unused pure expression or super */ null && (Tabs)));

// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 6 modules
var collapse = __webpack_require__(54907);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Collapse.js

function Collapse_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n\n    .ant-collapse-header {\n      color: ",
        ";\n    }\n  "
    ]);
    Collapse_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Collapse_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Collapse_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var types = {
    basic: (0,styled_components_browser_esm/* css */.iv)(Collapse_templateObject(), color/* default.light */.Z.light, color/* default.nightRider */.Z.nightRider)
};
var Collapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).attrs(function(props) {
    return {
        type: props.type || "basic"
    };
}).withConfig({
    componentId: "sc-291816d3-0"
})(Collapse_templateObject1(), function(param) {
    var type = param.type;
    return types[type];
});
/* harmony default export */ var common_Collapse = ((/* unused pure expression or super */ null && (Collapse)));

// EXTERNAL MODULE: ./node_modules/antd/es/steps/index.js + 3 modules
var steps = __webpack_require__(91756);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Steps.js

function Steps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-steps-item-process .ant-steps-item-icon {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    Steps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Steps = (0,styled_components_browser_esm/* default */.ZP)(steps/* default */.Z).withConfig({
    componentId: "sc-8b4bf621-0"
})(Steps_templateObject(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);
/* harmony default export */ var common_Steps = ((/* unused pure expression or super */ null && (Steps)));

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Table.js
var Table = __webpack_require__(77148);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Pagination.js
var Pagination = __webpack_require__(35266);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var Tooltip = __webpack_require__(39211);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/@deprecated-ui/common/Radio.js

function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-wrapper:hover .ant-radio,\n  .ant-radio:hover .ant-radio-inner,\n  .ant-radio-input:focus + .ant-radio-inner,\n  .ant-radio-checked .ant-radio-inner {\n    background-color: ",
        ";\n  }\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ",
        ";\n  }\n  .ant-radio-inner::after {\n    background-color: ",
        ";\n  }\n"
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var Radio = ((0,styled_components_browser_esm/* default */.ZP)(es_radio/* default */.ZP).withConfig({
    componentId: "sc-8f5670d5-0"
})(Radio_templateObject(), color/* default.veryLightGrey */.Z.veryLightGrey, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light));

;// CONCATENATED MODULE: ./src/@deprecated-ui/common/index.js


































/***/ }),

/***/ 97214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var withSpacing = function(Component) {
    return function(props) {
        var spacing = (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .t)(props);
        var WithSpacingComponent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(Component).attrs(function(componentProps) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, componentProps, spacing);
        }).withConfig({
            componentId: "sc-bfeb3364-0"
        })(_templateObject1(), function(componentProps) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(componentProps));
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WithSpacingComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withSpacing);


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 82603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ company_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/index.js + 5 modules
var common = __webpack_require__(48308);
;// CONCATENATED MODULE: ./src/@deprecated-ui/company/Navbar.js
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc((100%-45px) / 2);\n\n  @media ",
        " {\n    width: calc((100%-45px) / 3);\n  }\n\n  @media ",
        " {\n    width: calc((100%-45px) / 4);\n  }\n\n  @media ",
        " {\n    width: calc((100%-45px) / 6);\n  }\n\n  @media ",
        " {\n    width: calc((100%-45px) / 9);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'ProximaNovaRg';\n  text-decoration: none;\n  color: ",
        ";\n  cursor: pointer;\n  border-left: 1px solid ",
        ";\n\n  :first-child {\n    border-left: unset;\n  }\n\n  :focus,\n  :active {\n    color: ",
        ";\n    background: ",
        ";\n    :hover {\n      color: ",
        ";\n    }\n  }\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  display: flex;\n  border-top: 1px solid ",
        ";\n  box-sizing: border-box;\n  width: 100%;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n  flex-wrap: ",
        ";\n  width: ",
        ";\n\n  & > a {\n    ",
        ";\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      height: auto;\n      opacity: 1;\n      visibility: visible;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  position: absolute;\n  right: 0;\n  height: 0px;\n  opacity: 0;\n  visibility: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ",
        ";\n  border-top: none;\n  padding: 10px 0;\n  transition: all 0.2s ease-in-out;\n  z-index: 5;\n\n  a:nth-child(-n + ",
        ") {\n    display: none;\n  }\n\n  & > a {\n    ",
        ";\n    border-left: unset;\n    text-align: right;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-width: ",
        ";\n  border-color: ",
        ";\n  border-style: solid;\n  border-left: 1px solid ",
        ";\n  cursor: pointer;\n\n  ::after {\n    content: '';\n    display: ",
        ";\n    width: 50px;\n    height: 1px;\n    background-color: ",
        ";\n    position: absolute;\n    bottom: -1px;\n    z-index: 2;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 40px;\n\n  & > span {\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var navigationWidthByDevice = (0,styled_components_browser_esm/* css */.iv)(_templateObject(), device/* default.mobileS */.Z.mobileS, device/* default.mobileL */.Z.mobileL, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var Navigation = (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), color/* default.dimGray */.Z.dimGray, color/* default.gainsboro */.Z.gainsboro, color/* default.primary */.Z.primary, color/* default.aliceBlue */.Z.aliceBlue, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);
var NavBarWebWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f65ddf2d-0"
})(_templateObject2(), color/* default.light */.Z.light, color/* default.lowgray */.Z.lowgray, color/* default.gainsboro */.Z.gainsboro);
var HorizontalNavigations = (0,styled_components_browser_esm/* default */.ZP)(common/* Flex */.kC).withConfig({
    componentId: "sc-f65ddf2d-1"
})(_templateObject3(), function(param) {
    var isNavigationBlock = param.isNavigationBlock;
    return isNavigationBlock ? "unset" : "wrap";
}, function(param) {
    var isNavigationBlock = param.isNavigationBlock;
    return isNavigationBlock ? "100%" : "auto";
}, Navigation, function(param) {
    var isNavigationBlock = param.isNavigationBlock;
    return isNavigationBlock ? "100%" : navigationWidthByDevice;
});
var VerticalNavigations = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f65ddf2d-2"
})(_templateObject5(), color/* default.lowgray */.Z.lowgray, function(props) {
    return props.elementToShow;
}, Navigation, function(param) {
    var isOpen = param.isOpen;
    return isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), color/* default.light */.Z.light);
});
var NavMoreLogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f65ddf2d-3"
})(_templateObject6(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "0px 1px" : "0px";
}, color/* default.lowgray */.Z.lowgray, color/* default.gainsboro */.Z.gainsboro, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "block" : "none";
}, color/* default.light */.Z.light);
var Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f65ddf2d-4"
})(_templateObject7());
var NavMoreWrapper = function(param) {
    var ExpandLogo = param.ExpandLogo, children = param.children, elementToShow = param.elementToShow;
    var ref = (0,react.useState)(true), hideModal = ref[0], setModal = ref[1];
    var navMoreRef = (0,react.useRef)();
    var onNavMoreClick = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        if (navMoreRef.current.contains(e.target)) {
            return setModal(!hideModal);
        }
        return setModal(true);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", onNavMoreClick);
        return function() {
            document.removeEventListener("click", onNavMoreClick);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Relative, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMoreLogoWrapper, {
                ref: navMoreRef,
                isOpen: !hideModal,
                onClick: function(e) {
                    return onNavMoreClick(e);
                },
                children: elementToShow !== children.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLogo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalNavigations, {
                isOpen: !hideModal,
                elementToShow: elementToShow,
                children: children
            })
        ]
    });
};
var NavMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f65ddf2d-5"
})(_templateObject8(), color/* default.highgray */.Z.highgray, function(param) {
    var isOpen = param.isOpen;
    return isOpen ? color/* default.primary */.Z.primary : "";
});
var NavMoreLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavMore, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        ]
    });
};
var NavBarComponent = function(param) {
    var className = param.className, children = param.children, _expandNavLogo = param.expandNavLogo, expandNavLogo = _expandNavLogo === void 0 ? function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    } : _expandNavLogo;
    var ref = (0,react.useState)([]), moreNavElement = ref[0], setMoreNavElement = ref[1];
    var navHorizontalRef = (0,react.useRef)();
    var ExpandNavLogo = expandNavLogo;
    (0,react.useEffect)(function() {
        var navigation = navHorizontalRef.current.children;
        var moreNavigation = (0,_to_consumable_array/* default */.Z)(navigation).filter(function(e) {
            return e.offsetTop === 0;
        }).map(function(e) {
            return e.innerText;
        });
        setMoreNavElement(moreNavigation);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarWebWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalNavigations, {
                isNavigationBlock: moreNavElement.length === children.length,
                ref: navHorizontalRef,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMoreWrapper, {
                ExpandLogo: ExpandNavLogo,
                elementToShow: moreNavElement.length,
                children: children
            })
        ]
    });
};
/* harmony default export */ var Navbar = ({
    NavMoreLogo: NavMoreLogo,
    NavBarComponent: NavBarComponent
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
;// CONCATENATED MODULE: ./src/features/company/Navbar/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  margin-bottom: 20px;\n  position: relative;\n  width: 100%;\n  &.my {\n    width: 118px;\n  }\n\n  > .navbar-company {\n    position: relative;\n\n    &.my {\n      a {\n        background: white;\n      }\n    }\n\n    > div:first-child {\n      position: static;\n      width: 100%;\n\n      & > a {\n        border-bottom: 1px solid ",
        ";\n        flex: 1 0 auto;\n        width: calc((100% - 45px) / 2);\n\n        @media ",
        " {\n          width: calc((100% - 45px) / 3);\n        }\n\n        @media ",
        " {\n          width: calc((100% - 45px) / 4);\n        }\n\n        @media ",
        " {\n          width: calc((100% - 45px) / 6);\n        }\n\n        @media ",
        " {\n          width: calc((100% - 45px) / 8) !important;\n        }\n      }\n    }\n    > div {\n      z-index: 101;\n    }\n    > div:last-child {\n      > div:first-child {\n        border-right: none;\n      }\n\n      > div:last-child {\n        border-right: 1px solid ",
        ";\n        border-top: 1px solid ",
        ";\n        padding: 0;\n        right: -1px;\n        z-index: 101;\n      }\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n        color: ",
        " !important;\n      "
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n  cursor: pointer;\n  text-transform: capitalize;\n\n  ",
        "\n\n  :hover {\n    color: ",
        " !important;\n  }\n\n  .analyst-tooltip {\n    max-width: none;\n    z-index: 99;\n  }\n\n  .ant-tooltip-inner {\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    margin: 0;\n    max-width: 350px;\n    padding: 0;\n  }\n\n  .ant-tooltip-arrow {\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  color: ",
        ";\n  display: flex;\n  height: 34px;\n  justify-content: center;\n  padding: 8px 10px;\n  text-decoration: none;\n  text-transform: none;\n\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .analyst-tooltip {\n    max-width: none;\n    z-index: 99;\n  }\n\n  .ant-tooltip-inner {\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    font-size: 14px;\n    justify-content: center;\n    margin: 0;\n    max-width: 350px;\n    padding: 0;\n  }\n\n  .ant-tooltip-arrow {\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var NavbarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-986485f-0"
})(styled_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro, device/* default.mobileS */.Z.mobileS, device/* default.mobileL */.Z.mobileL, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro);
var NavLink = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    align: "center",
    as: "a",
    height: "40px",
    padding: "0 12px"
}).withConfig({
    componentId: "sc-986485f-1"
})(styled_templateObject2(), color/* default.highempahis */.Z.highempahis, // @ts-expect-error
function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject1(), color/* default.aliceBlue */.Z.aliceBlue, color/* default.primary */.Z.primary);
}, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);
var TooltipLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-986485f-2"
})(styled_templateObject3(), color/* default.light */.Z.light, color/* default.light */.Z.light);
var AnalystTooltip = (0,styled_components_browser_esm/* default */.ZP)(tooltip/* default */.Z).withConfig({
    componentId: "sc-986485f-3"
})(styled_templateObject4(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);


// EXTERNAL MODULE: ./src/features/company/constants.ts
var constants = __webpack_require__(55564);
;// CONCATENATED MODULE: ./src/features/company/Navbar/index.tsx
/* eslint-disable react/no-array-index-key */ 











var Navbar_NavBarComponent = Navbar.NavBarComponent, Navbar_NavMoreLogo = Navbar.NavMoreLogo;
var PATH_ANALYST = constants/* TAB_LIST */.YS[constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST].path;
var TOOLTIP_ANALYST_TEXT = "Kompilasi target analyst dari berbagai sekuritas";
function Navbar_Navbar(param) {
    var active = param.active, tabs = param.tabs, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock, className = param.className, _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn, _userId = param.userId, userId = _userId === void 0 ? "" : _userId, onClickTab = param.onClickTab, _onSendClevertapEvent = param.onSendClevertapEvent, onSendClevertapEvent = _onSendClevertapEvent === void 0 ? function() {} : _onSendClevertapEvent;
    var router = (0,next_router.useRouter)();
    var symbol = router.query.symbol;
    var ref = (0,react.useState)(false), isShowingAnalystTooltip = ref[0], setIsShowingAnalystTooltip = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref1.data;
    var tmp = profileData.country, profileCountry = tmp === void 0 ? "ID" : tmp;
    var returnNotLogin = function() {
        if (isCompanyStock) {
            onClickTab(true);
        } else {
            router.push("/register");
        }
    };
    var onSelectTab = function(event, param) {
        var path = param.path;
        event.preventDefault();
        itemNavigationOnClick(getPathName(path));
        if (isLoggedIn) {
            router.push("/symbol/".concat(symbol).concat(path), undefined, {
                scroll: false
            });
        } else {
            returnNotLogin();
        }
    };
    var getPathName = function(path) {
        try {
            return path.slice(1);
        } catch (_error) {
            return path;
        }
    };
    var checkIsActive = function(value) {
        // Make stream active if path is /buy and value is empty
        if (active === constants/* TAB_LIST_NAME.BUY */.p.BUY && value === "") return true;
        return active === getPathName(value);
    };
    var getAnalystUserIds = function() {
        var analystUserIds = localStorage.getItem("analystUserIds");
        var analystUserIdsArray = [];
        if (analystUserIds) {
            analystUserIdsArray = analystUserIds.split(",");
        }
        return analystUserIdsArray;
    };
    var setAnalystUserIds = function(analystUserIds) {
        var newAnalystUserIds = (0,_to_consumable_array/* default */.Z)(analystUserIds);
        newAnalystUserIds.push(String(userId));
        localStorage.setItem("analystUserIds", newAnalystUserIds.join());
    };
    var isUserIdExistsInAnalystUserIds = function(analystUserIds) {
        return analystUserIds.includes(String(userId));
    };
    var onCloseAnalystTooltip = function() {
        // Update analystUserIds
        var analystUserIds = getAnalystUserIds();
        if (!isUserIdExistsInAnalystUserIds(analystUserIds)) {
            setAnalystUserIds(analystUserIds);
        }
        // Hide Analyst Tooltip
        setIsShowingAnalystTooltip(false);
    };
    var itemNavigationOnClick = function(itemName) {
        if (itemName === constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST) {
            onCloseAnalystTooltip();
        }
        // need to set timeout for sending clevertap event due to
        // RaceCondition issue between Http Request & Switching Page route
        onSendClevertapEvent({
            tabPath: itemName,
            timeout: 500
        });
    };
    var isLoggedInAndHaveUserId = isLoggedIn && !!userId;
    var shouldShowAnalystTooltip = function(analystUserIds) {
        return isLoggedInAndHaveUserId && !isUserIdExistsInAnalystUserIds(analystUserIds) && !isShowingAnalystTooltip;
    };
    (0,react.useEffect)(function() {
        var analystUserIds = getAnalystUserIds();
        if (shouldShowAnalystTooltip(analystUserIds)) {
            setIsShowingAnalystTooltip(true);
        }
    }, [
        userId,
        active
    ]);
    var MoreMenu = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-cy": data_cy/* default.COMPANY.NAVBAR_MORE_MENU */.Z.COMPANY.NAVBAR_MORE_MENU,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_NavMoreLogo, {})
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_NavBarComponent, {
            className: "navbar-company ".concat(profileCountry.toLowerCase()),
            expandNavLogo: MoreMenu,
            children: tabs.map(function(item, index) {
                return item.path === PATH_ANALYST ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalystTooltip, {
                    placement: "top",
                    visible: isShowingAnalystTooltip,
                    overlayClassName: "analyst-tooltip",
                    color: color/* default.primary */.Z.primary,
                    getPopupContainer: function(triggerNode) {
                        return triggerNode;
                    },
                    title: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(symbol).concat(item.path),
                            passHref: true,
                            scroll: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipLink, {
                                onClick: function() {
                                    return itemNavigationOnClick(getPathName(item.path));
                                },
                                children: TOOLTIP_ANALYST_TEXT
                            })
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/symbol/".concat(symbol).concat(item.path),
                        passHref: true,
                        scroll: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                            onClick: function(e) {
                                return onSelectTab(e, item);
                            },
                            // @ts-expect-error
                            isActive: checkIsActive(item.path),
                            "data-cy": "company-navigation-".concat(item.label.toLocaleLowerCase().replace(" ", "-")),
                            children: item.label
                        }, index)
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/symbol/".concat(symbol).concat(item.path),
                    passHref: true,
                    scroll: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink, {
                        onClick: function(e) {
                            return onSelectTab(e, item);
                        },
                        // @ts-expect-error
                        isActive: checkIsActive(item.path),
                        "data-cy": "company-navigation-".concat(item.label.toLocaleLowerCase().replace(" ", "-")),
                        children: item.label
                    }, index)
                });
            })
        })
    });
}
/* harmony default export */ var company_Navbar = (Navbar_Navbar);


/***/ }),

/***/ 55564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ chartTimeframes; },
/* harmony export */   "K1": function() { return /* binding */ TAB_ANALYST_NEW_NAME; },
/* harmony export */   "PV": function() { return /* binding */ CHART_COLOR; },
/* harmony export */   "R1": function() { return /* binding */ SOURCE_MENU; },
/* harmony export */   "YS": function() { return /* binding */ TAB_LIST; },
/* harmony export */   "hW": function() { return /* binding */ FR_CHART_TYPES; },
/* harmony export */   "l3": function() { return /* binding */ SENTIMENT_INDICATOR_COLORS; },
/* harmony export */   "lt": function() { return /* binding */ priceChange; },
/* harmony export */   "p": function() { return /* binding */ TAB_LIST_NAME; },
/* harmony export */   "rn": function() { return /* binding */ chartTimeframesFR; },
/* harmony export */   "sX": function() { return /* binding */ CORP_ACTIONS; },
/* harmony export */   "wm": function() { return /* binding */ CORP_ACTION_NAVS; }
/* harmony export */ });
/* unused harmony exports TAB_CORP_ACTION_NEW_NAME, CLEVERTAP_ANALYST, CLEVERTAP_SEASONALITY */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22147);
/* harmony import */ var _types_company_d__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82964);





var CORP_ACTIONS = {
    dividend: "Dividend",
    stocksplit: "Stock Split",
    reversesplit: "Reverse Split",
    rightissue: "Right Issue",
    warrant: "Warrant",
    bonus: "Bonus",
    tenderoffer: "Tender Offer",
    pubex: "Pubex",
    rups: "RUPS"
};
var CORP_ACTION_NAVS = [
    {
        value: "all",
        label: "All"
    }, 
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Object.entries(CORP_ACTIONS).map(function(param) {
    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), value = _param[0], label = _param[1];
    return {
        value: value,
        label: label
    };
})));
var chartTimeframes = [
    {
        value: "today",
        label: "1D"
    },
    {
        value: "1w",
        label: "1W"
    },
    {
        value: "1m",
        label: "1M"
    },
    {
        value: "3m",
        label: "3M"
    },
    {
        value: "ytd",
        label: "YTD"
    },
    {
        value: "1y",
        label: "1Y"
    },
    {
        value: "3y",
        label: "3Y"
    },
    {
        value: "5y",
        label: "5Y"
    }, 
];
var priceChange = {
    netral: {
        icon: "",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].nobel */ .Z.nobel
    },
    up: {
        icon: "icon-symbol_up",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].primary */ .Z.primary
    },
    down: {
        icon: "icon-symbol_down",
        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].sunsetOrange */ .Z.sunsetOrange
    }
};
var SENTIMENT_INDICATOR_COLORS = [
    {
        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].royalBlue */ .Z.royalBlue,
        label: "Pessimistic"
    },
    {
        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].steelBlue */ .Z.steelBlue,
        label: "Cautious"
    },
    {
        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].scooter */ .Z.scooter,
        label: "Neutral"
    },
    {
        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].java */ .Z.java,
        label: "Optimstic"
    },
    {
        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_0__/* ["default"].jade */ .Z.jade,
        label: "Positive"
    }, 
];
var CHART_COLOR = [
    "#3366FF",
    "#ff00ff",
    "#ff7900",
    "#008700",
    "#ff0000",
    "#1c1cb5",
    "#00ff00",
    "#7f33ba",
    "#e83535",
    "#800000",
    "#666666",
    "#000000", 
];
var TAB_LIST_NAME = _types_company_d__WEBPACK_IMPORTED_MODULE_1__/* .TabListNameEnums */ .A;
var _obj;
var TAB_LIST = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.STREAM, {
    label: "Stream",
    path: "",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.NEWS, {
    label: "News",
    path: "/news",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.KEYSTATS, {
    label: "Key Stats",
    path: "/keystats",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.ANALYST, {
    label: "Analysis",
    path: "/analyst",
    isNewFeature: true
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.FINANCIALS, {
    label: "Financials",
    path: "/financials",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.FUNDACHART, {
    label: "Fundachart",
    path: "/fundachart",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.SEASONALITY, {
    label: "Seasonality",
    path: "/seasonality",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.CHARTBIT, {
    label: "Chartbit",
    path: "/chartbit",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.COMPARISON, {
    label: "Comparison",
    path: "/comparison",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.INSIDER, {
    label: "Insider",
    path: "/insider",
    isNewFeature: true
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.PROFILE, {
    label: "Profile",
    path: "/profile",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.CORP_ACTION, {
    label: "Corp. Action",
    path: "/corpaction",
    isNewFeature: false
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, TAB_LIST_NAME.CONSENSUS, {
    label: "EPS Estimate",
    path: "/consensus",
    isNewFeature: false
}), _obj);
var TAB_ANALYST_NEW_NAME = "analysis";
var TAB_CORP_ACTION_NEW_NAME = "corpaction";
var CLEVERTAP_ANALYST = "Analyst Ratings - Tab Menu Selected";
var CLEVERTAP_SEASONALITY = "Seasonality - Tab Menu Selected";
var SOURCE_MENU = "Menu";
var FR_CHART_TYPES = [
    {
        value: "yield",
        label: "Yield"
    },
    {
        value: "buy_price_rate",
        label: "Harga Beli"
    },
    {
        value: "sell_price_rate",
        label: "Harga Jual"
    }, 
];
var chartTimeframesFR = [
    {
        value: "1d",
        label: "1D"
    },
    {
        value: "1m",
        label: "1M"
    },
    {
        value: "3m",
        label: "3M"
    },
    {
        value: "ytd",
        label: "YTD"
    },
    {
        value: "1y",
        label: "1Y"
    },
    {
        value: "3y",
        label: "3Y"
    },
    {
        value: "5y",
        label: "5Y"
    },
    {
        value: "all",
        label: "All"
    }, 
];



/***/ })

}]);